<template>
  <span v-html="highlightedText"></span>
</template>

<script>
export default {
  props: [
    'searchKeyword',
    'textItem'
  ],
  computed: {
    highlightedText () {
      if (!this.searchKeyword) {
        return this.textItem
      }
      const indices = this.findIndices(this.textItem.toLowerCase(), this.searchKeyword.toLowerCase())
      if (!indices) {
        return this.textItem
      }
      let result = ''
      for (let i = 0; i < this.textItem.length; i++) {
        if (!indices[i]) {
          result += this.textItem.charAt(i)
        } else {
          result += this.highlightStyle + this.textItem.substring(i, indices[i]) + '</mark>'
          i = indices[i] - 1
        }
      }
      return result
    }
  },
  methods: {
    findIndices (textItem, searchKeyword) {
      if (textItem.indexOf(searchKeyword) === -1) {
        return null
      }
      let indices = {}
      const len = textItem.length
      for (let i = 0; i !== len; i++) {
        const index = textItem.substring(i, len).indexOf(searchKeyword)
        if (index === -1) {
          return indices
        }
        indices[i + index] = i + index + searchKeyword.length
        i = indices[i + index] - 1
      }
      return indices
    }
  },
  data () {
    return {
      highlightStyle: '<mark style="color: #ff8400; background-color: transparent;">'
    }
  }
}
</script>
